import React from "react";
import { Form } from "react-bootstrap";
import { useField, useFormikContext } from "formik";
import { at } from "lodash";

/**
 * The "onChange" event is available inside (...field)
 * @param {string} props.label - display checkbox description/name/title
 * @param {string} props.name - field name of checkbox
 * @param {boolean} props.defaultChecked - html attribute for default checked
 * @returns {JSX}
 */
const BRadioButton = ({  defaultChecked, data, ...props }) => {
    // const [field] = useField(props);
     const [field, meta] = useField(props);
      const { setFieldValue} = useFormikContext();
    function _renderHelperText() {
        const [touched, error] = at(meta, "touched", "error");
        if (touched && error) {
            return <Form.Text>{error}</Form.Text>;
        }
    }

    function _onChange(selection) {
        console.log({selection})
        setFieldValue(field?.name, selection);
    }

    console.log({field})

    return (
        <div className="d-flex flex-row align-items-center">
            {data.map((item) => {
                return (
                    <Form.Group>
                        <div className="radio d-inline">
                            <Form.Control
                                name={field.name}
                                type="radio"
                                id={item.label}
                                defaultChecked={item.defaultChecked}
                                checked={field.value === item.value}
                                onChange={_onChange}
                                {...props}
                            />
                            <Form.Label htmlFor={field.value} className="cr">
                                {item.label}
                            </Form.Label>
                        </div>
                    </Form.Group>
                );
            })}
            {_renderHelperText()}
        </div>
    );
};

BRadioButton.defaultProps = {
    defaultChecked: false,
};

export default BRadioButton;
